const SAVE_FOR_LATER_LIST_TYPE = 'save_for_later';
const SAVE_FOR_LATER_DEFAULT_LIST_NAME = 'Save For Later';
const DEFAULT_SHOPPING_LIST_NAME = 'save_for_later List'; // Fallback for API shoppingListName param
const SAVE_FOR_LATER_MAX_ITEMS = 100;
const SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS = 10;
const SAVE_FOR_LATER_CONFIRMATION_TIMEOUT_MS = 8000;

const ACTION_TYPES = {
    SET_SAVE_FOR_LATER_LOADING: 'SET_SAVE_FOR_LATER_LOADING',
    SET_SAVE_FOR_LATER_ERROR: 'SET_SAVE_FOR_LATER_ERROR',
    UPDATE_SAVE_FOR_LATER_LISTS: 'UPDATE_SAVE_FOR_LATER_LISTS',
    UPDATE_SAVE_FOR_LATER_ITEMS: 'UPDATE_SAVE_FOR_LATER_ITEMS',
    ADD_SAVE_FOR_LATER_ITEM_OPTIMISTIC: 'ADD_SAVE_FOR_LATER_ITEM_OPTIMISTIC',
    REMOVE_SAVE_FOR_LATER_ITEM_OPTIMISTIC: 'REMOVE_SAVE_FOR_LATER_ITEM_OPTIMISTIC',
    SET_MOVING_SKU: 'SET_MOVING_SKU',
    REMOVE_MOVING_SKU: 'REMOVE_MOVING_SKU',
    CLEAR_MOVING_SKUS: 'CLEAR_MOVING_SKUS',
    SET_SAVE_FOR_LATER_CONFIRMATION: 'SET_SAVE_FOR_LATER_CONFIRMATION',
    CLEAR_SAVE_FOR_LATER_CONFIRMATION: 'CLEAR_SAVE_FOR_LATER_CONFIRMATION',
    SET_BASKET_CONFIRMATION: 'SET_BASKET_CONFIRMATION',
    CLEAR_BASKET_CONFIRMATION: 'CLEAR_BASKET_CONFIRMATION'
};

const SAVE_FOR_LATER_FULFILLMENT_TYPES = {
    STANDARD: 'standard',
    SAMEDAY: 'sameday',
    AUTOREPLEN: 'auto_replen',
    BOPIS: 'bopis'
};

const SAVE_FOR_LATER_CONFIRMATION_CONTEXTS = {
    BASKET: 'basket',
    CAROUSEL: 'carousel',
    FLYOUT: 'flyout'
};

const SAVE_FOR_LATER_VIEW_TYPES = {
    CAROUSEL: 'carousel',
    FLYOUT: 'flyout'
};

const SAVE_FOR_LATER_ANALYTICS = {
    EVENT_CATEGORY: 'save_for_later'
};

const buildSaveForLaterSkuKey = ({ skuId, productId }) => {
    return `${skuId || ''}:${productId || ''}`;
};

export {
    SAVE_FOR_LATER_LIST_TYPE,
    SAVE_FOR_LATER_DEFAULT_LIST_NAME,
    DEFAULT_SHOPPING_LIST_NAME,
    SAVE_FOR_LATER_MAX_ITEMS,
    SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS,
    SAVE_FOR_LATER_CONFIRMATION_TIMEOUT_MS,
    ACTION_TYPES,
    SAVE_FOR_LATER_FULFILLMENT_TYPES,
    SAVE_FOR_LATER_CONFIRMATION_CONTEXTS,
    SAVE_FOR_LATER_VIEW_TYPES,
    SAVE_FOR_LATER_ANALYTICS,
    buildSaveForLaterSkuKey
};
